import {StyleSheet} from "aphrodite";
import * as React from "react";
import {ReactEditor, useSlate, type RenderElementProps} from "slate-react";

import {color, spacing} from "@khanacademy/wonder-blocks-tokens";
import {Body} from "@khanacademy/wonder-blocks-typography";

import {isWithinTableHeader} from "../helpers/table-helpers.ts";

export default function TableCellNode(
    props: RenderElementProps,
): React.ReactElement {
    const {element, attributes, children} = props;

    const editor = useSlate();
    const path = ReactEditor.findPath(editor, element);
    const renderTh = isWithinTableHeader(editor, path);
    const tag = renderTh ? "th" : "td";

    return (
        <Body
            {...attributes}
            style={[styles.cell, renderTh && styles.th]}
            tag={tag}
        >
            {children}
        </Body>
    );
}

const styles = StyleSheet.create({
    cell: {
        display: "table-cell",
        padding: spacing.xSmall_8,
        border: `1px solid ${color.offBlack16}`,
        position: "relative",
    },
    th: {
        backgroundColor: color.offBlack8,
        fontWeight: "bold",
    },
});
